import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_EditIcon = _resolveComponent("EditIcon")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_BaseTable = _resolveComponent("BaseTable")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    title: "Словарь",
    "header-buttons": [
      {
        text: 'Добавить слово',
        href: _ctx.getTermFormUrl({ termId: 'create' }),
      },
    ]
  }, {
    content: _withCtx(() => [
      _createVNode(_component_BaseTable, {
        "column-defs": _ctx.columnDefs,
        "row-data": _ctx.rowData,
        loading: _ctx.isRowDataLoading,
        "error-message": _ctx.errorMessage
      }, {
        "cell(link-to-links)": _withCtx(({ row }) => [
          _createVNode(_component_BaseButton, {
            href: _ctx.getLinkToLinkList(row.id),
            variant: "outline-secondary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Ссылки (" + _toDisplayString(row.linksCount) + ") ", 1)
            ]),
            _: 2
          }, 1032, ["href"])
        ]),
        "cell(actions)": _withCtx(({ row }) => [
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Edit",
            disabled: _ctx.isBusy(row.id),
            href: _ctx.getTermFormUrl({ termId: row.id })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_EditIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "href"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Delete",
            disabled: _ctx.isBusy(row.id),
            onClick: ($event: any) => (_ctx.handleTermDelete(row.id))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DeleteIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]),
        _: 1
      }, 8, ["column-defs", "row-data", "loading", "error-message"])
    ]),
    _: 1
  }, 8, ["header-buttons"]))
}